import { exp } from "@amcharts/amcharts5/.internal/core/util/Ease";
import { Link } from "@mui/material";
import {
  addTab,
  clearActiveTab,
} from "../../../../redux/features/TabsManager/tabSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { useContext, useEffect, useRef, useState } from "react";
import { PartRequestManagementContext } from "../../context/PartRequestManagementContext";
import "./QuoteTrack.css";
import { DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { QuoteList } from "./QuoteList";
import { DialogContext } from "../../../../contexts/DialogContext";
import {
  QuoteOrderContext,
  QuoteOrderContextProvider,
} from "../../context/QuoteOrderContext";
import { use } from "react";
import NewOrder from "../Orders/NewOrder";
import { from } from "rxjs";
import { NewMultipleOrder } from "../Orders/NewMultipleOrder";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import { FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
const SearchBarContainer = () => {
  const [inputValue, setInputValue] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const didMount = useRef(false);
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(inputValue);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [inputValue]);

  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    // onSearch(debouncedValue);
  }, [debouncedValue]);
  return <input placeholder="Search" onChange={handleChange} />;
};

const AddButtonContainer = () => {
  const { quoteToOrderList, setQuoteToOrderList, setUpdateInfoList } =
    useContext(QuoteOrderContext);

  const { openDialog, closeDialog } = useContext(DialogContext);

  const deselectAllQuotes = () => {
    setQuoteToOrderList([]);
  };

  const saveSuccess = () => {
    setUpdateInfoList(new Date().getTime());
    setQuoteToOrderList([]);
  };

  const onNewOrder = () => {
    let isMultivendor = false;
    let uniqueVendors = [];
    if (quoteToOrderList) {
      uniqueVendors = new Set(quoteToOrderList.map((part) => part.vendor_id));
      isMultivendor = uniqueVendors.size > 1;
    }
    if (isMultivendor) {
      const grouped = Object.values(
        quoteToOrderList.reduce((acc, item) => {
          const vendorId = item.vendor_id;
          if (!acc[vendorId]) {
            acc[vendorId] = {
              company_id: item.company_id,
              vendor_id: item.vendor_id,
              score: item.score,
              vendor_name: item.vendor_name,
              company_name: item.company_name,
              currency: item.currency,
              pns: [],
            };
          }
          acc[vendorId].pns.push(item);
          return acc;
        }, {})
      );

      openDialog({
        component: NewMultipleOrder,
        props: {
          parts: [],
          fromQuote: true,
          quoteToOrderList: quoteToOrderList,
          close: closeDialog,
          uniqueVendors: grouped,
          okAction: () => saveSuccess(),
        },
      });
    } else {
      openDialog({
        component: NewOrder,
        props: {
          parts: [],
          fromQuote: true,
          quoteToOrderList: quoteToOrderList,
          close: closeDialog,
          okAction: () => saveSuccess(),
        },
      });
    }
  };
  return (
    <div className="buttons-container-order-actions">
      <button
        onClick={() => deselectAllQuotes()}
        className={`filled iconTextButton ${
          quoteToOrderList.length == 0 ? "disabled" : ""
        }`}
      >
        <span>Deselect Quote(s)</span>
      </button>
      <button
        onClick={() => onNewOrder()}
        className={`filled iconTextButton ${
          quoteToOrderList.length == 0 ? "disabled" : ""
        }`}
      >
        <i className="icon-quote"></i> <span>New Order</span>
      </button>
      {/* <SortingButton></SortingButton> */}
    </div>
  );
};

export const QuoteTrack = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/customdashboard");
      }}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/supplychain");
      }}
    >
      Supply Chain
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Quote Tracking
    </Link>,
  ];
  function generateUUID() {
    return crypto.randomUUID();
  }

  useEffect(() => {
    dispatch(
      addTab({
        icon: "icon-quote-track",
        color: "#25C2C0",
        path: "/supplychain/quote-tracking",
        title: "Quote Tracking",
        isPinned: false,
        componentKey: "QuoteTrack",
        id: 21,
        date: generateUUID(),
        isModule: false,
      })
    );
  }, []);

  return (
    <QuoteOrderContextProvider>
      <PermissionsProvider resourceId={21}>
        <SortingContainer>
          <div className="quote-tracking-component">
            <div className="nav-header">
              <NavBarContainer
                dataBreadCrumbs={"/supplychain/quote-tracking"}
                appIcon={"icon-quote-track"}
                moduleIcon={"icon-settings"}
                moduleColor="#25C2C0"
                title={"Quote Tracking"}
                menuTitle={"Supply Chain"}
                moduleId={12}
                isLocalSearch
                searchActions={
                  <>
                   <FiltersManager onButtonClick={() => console.warn("FiltersManager button clicked")} />
                    <SortingButton></SortingButton>
                  </>
                }
                screenActions={
                  <>
                    <AddButtonContainer />
                  </>
                }
              />
            </div>

            <div className="quote-tracking-component-content">
              <div className="content-header">
                <hr />

                {/* <div className="quote-tracking-component-content-header">
                  <span className="left-container">
                    <b>RFQ Requests</b>
                    <div className="search-bar-input">
                      <SearchBarContainer />
                      <i className="icon-search"></i>
                    </div>
                  </span>
                  <AddButtonContainer />
                </div> */}
              </div>

              <DropdownsProvider>
                <QuoteList />
              </DropdownsProvider>
            </div>
          </div>
        </SortingContainer>
      </PermissionsProvider>
    </QuoteOrderContextProvider>
  );
};

export default QuoteTrack;

const NavBarContainer = ({ ...props }) => {
  //TODO: use search callback from respective context
  // const { onSearch } = useContext(TypeSeriesConfigurationContext);
  const { onSearch, quoteList } = useContext(QuoteOrderContext);
  return (
    <NavBar
      displayRecordsCount={true}
      totalRecords={quoteList?.length}
      searchInputProps={{ onTextChange: (e) => onSearch(e) }}
      {...props}
    />
  );
};

const SortingContainer = ({ children }) => {
  const { setSortingOrder} = useContext(QuoteOrderContext);

  return (
    <SortingProvider
      onOrderChange={(e) => setSortingOrder(e)}
      properties={{
        id: "Cod RFQ",
        part_number: "Requested By",
        required: "Company",
        issued: "Date Sent",
        remaining: "Total Vendors",
        pendingOrder: "Status",
      }}
    >
      {children}
    </SortingProvider>
  );
};
